import { handleActions } from 'redux-actions'
import { editPopupStatus } from 'actions/editPopup'

const defaultState = {
  open: false,
  itemToEdit: null,
  type: null
}

const reducer = handleActions(
  {
    [editPopupStatus]: (
      state,
      {
        payload: {
          data: { status }
        }
      }
    ) => {
      return status
    }
  },
  defaultState
)

export default reducer
